import React, { useState, useCallback } from 'react';
import clsx from 'clsx';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import { addCartItem } from '../../actions/cart';

import Card from 'react-bootstrap/Card';

import { CartItem } from '../../types';
import BackgroundImage from '../../components/BackgroundImage';
import Text from '../../components/Text';
import { FaMinus, FaPlus } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import AddToCartModal from '../../components/AddToCartModal';


export interface CartItemCardProps {
  item: CartItem;
  editable: boolean
}

const CartItemCard: React.FC<CartItemCardProps> = ({ item, editable }) => {
  const classes = useStyles();

  const imageSrc = item.twig?.mediaUrl || item.product.photo;
  const videoSrc = item.twig?.mediaType === 'VIDEO' && item.twig?.mediaUrl;
  const business = item.product.business;
  const uniqueName = item.product.uniqueName;
  const itemPrice = item.variant?.price ? item.variant?.price :
    item.product && item.product.originalPrice && item.product.discountedPrice && item.product.discountedPrice != 0 && item.product.originalPrice > item.product.discountedPrice ? item.product.discountedPrice :
      item.product && item.product.originalPrice ? item.product.originalPrice :
        item.twig?.price
  const dispatch = useDispatch();
  const [buyModalOpen, setBuyModalOpen] = useState(false);
  const handleToggleBuyModal = useCallback(() => {
    setBuyModalOpen(!buyModalOpen);
  }, [buyModalOpen]);
  return (
    <Card className={classes.card}>
      <AddToCartModal
        twig={item.twig}
        product={item.product}
        type="edit"
        item={item}
        show={buyModalOpen}
        onHide={handleToggleBuyModal}
        onClose={handleToggleBuyModal}
        centered
      />
      <Card.Header className={clsx('p-0', classes.header)}>
        {videoSrc ? (
          <div className={classes.videoBox}>
            <video className={classes.video} controls>
              <source src={videoSrc} />
            </video>
          </div>
        ) : (
          <div className={classes.imageBox}>
            <BackgroundImage src={imageSrc} height="380px" resizeMode="cover" />
          </div>
        )}
      </Card.Header>
      <Card.Body>
        <div className={clsx(classes.productDetailsBox, 'my-3')}>
          <div
            className={clsx(
              classes.productDetailsSidebox,
              classes.leftProductDetailsSidebox,
            )}
          >
            <BackgroundImage
              src={item.product.photo}
              height="75px"
              resizeMode="cover"
              className={classes.productDetailsImage}
            />
          </div>
          <div
            className={clsx(
              classes.productDetailsSidebox,
              classes.rightProductDetailsSidebox,
              'pl-2',
            )}
          >
            <Text className="mb-1" bold>
              <Link className={classes.link} to={`/${uniqueName}`}>
                {item.product.name}
              </Link>
            </Text>
            <Text>
              {itemPrice} {item.product.currency.currencyCode}
            </Text>
            <Text className="mb-1" bold>
              <Link className={classes.link} to={`/${business.uniqueName}`}>
                {business.name}
              </Link>
            </Text>
            {item.variant?.sku ? <Text>SKU: {item.variant?.sku}</Text> : null}
          </div>
        </div>
        <div className={classes.qtyBox}>
          <button
            disabled={!editable}
            className={classes.qtyBtn}
            type="button"
            onClick={handleToggleBuyModal}

          >
            <FaMinus />
          </button>
          <Text align="center" bold>
            {item.quantity}
          </Text>
          <button
            disabled={!editable}
            className={classes.qtyBtn}
            type="button"
            onClick={handleToggleBuyModal}

          >
            <FaPlus />
          </button>
        </div>
        {/* <div className={classes.qtyBox}>

          <button
            className={classes.qtyBtn}
            type="button"
            onClick={editItem}

          >
            <FaMinus />
          </button>
          <Text align="center" bold>
            Qty: {item.quantity}
          </Text>

          <button
            className={classes.qtyBtn}
            type="button"
            onClick={editItem}

          >
            <FaPlus />
          </button>

        </div> */}
        {item.variant?.optionValues.map((option) => {
          return (
            <div key={option.id} className={clsx(classes.optionBox, 'my-2')}>
              <Text className="m-0" capitalized bold>
                {option.name}
              </Text>
              {option.name.toLowerCase() === 'color' ? (
                <div
                  style={{
                    width: 17,
                    height: 17,
                    backgroundColor: option.value,
                    boxShadow:'0px 0px 5px 4px #eee',
                    borderRadius: '50%',
                  }}
                />
              ) : (
                <Text className="m-0">{option.value}</Text>
              )}
            </div>
          );
        })}
      </Card.Body>
    </Card >
  );
};

const useStyles = createUseStyles({
  card: {
    borderRadius: '15px',
    height: '100%',
    overflow: 'hidden',
  },
  header: {
    position: 'relative',
    overflow: 'hidden',
    height: '300px',
  },
  imageBox: {
    textAlign: 'center',
    maxHeight: '380px',
  },
  videoBox: {
    textAlign: 'center',
  },
  image: {},
  video: {
    width: '100%',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    cursor: 'pointer',
  },
  productDetailsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },
  productDetailsSidebox: {
    overflow: 'hidden',
  },
  leftProductDetailsSidebox: {
    flex: 0.35,
  },
  rightProductDetailsSidebox: {
    flex: 0.65,
  },
  productDetailsImage: {
    borderRadius: '10px',
  },
  optionBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  link: {
    color: '#000000',
    '&:hover': {
      color: '#000000',
    },
  },
  qtyBtn: {
    border: 'none',
    background: '#eee',
    borderRadius: '50%',
    width: '32px',
    height: '32px',
    '&:focus': {
      outline: 'none',
    },
  },
  qtyBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '7px',
    borderRadius: '30px',
  },
  qtyText: {}
});

export default CartItemCard;
